import { Component, OnInit } from '@angular/core';

import Swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConstants } from 'src/app/app.constant';
import { CommonService } from 'src/app/service/common.service';
import { DiseaseService } from 'src/app/service/disease.service';
import { TableColumn } from 'src/app/interfaces/TableColumn';
import { MenuService } from 'src/app/service/menu.service';


@Component({
  selector: 'app-disease',
  templateUrl: './disease.component.html',
  styleUrls: ['./disease.component.scss'],
})
export class DiseaseComponent implements OnInit {
  public displayedColumns: TableColumn[] = [
    {
      name: 'ID',
      dataKey: 'id',
      isSortable: true,
      cell: (element: Record<string, any>) => `${element['id']}`,
    },
    {
      name: 'Declared Disease Name',
      dataKey: 'name',
      isSortable: true,
      cell: (element: Record<string, any>) => `${element['name']}`,
    },
    {
      name: 'Display Term',
      dataKey: 'display_term',
      isSortable: true,
      cell: (element: Record<string, any>) => `${element['display_term']}`,
    },
    {
      name: 'SNOMED Name',
      dataKey: 'snomed_name',
      isSortable: true,
      cell: (element: Record<string, any>) => `${element['snomed_name']}`,
    },
    {
      name: 'SNOMED ID',
      dataKey: 'snomed_id',
      isSortable: true,
      cell: (element: Record<string, any>) => `${element['snomed_id']}`,
    },
  ];

  public title = 'Disease';
  public totalRows = 0;
  public pageSize = 10;
  public currentPage = 0;
  public filterValue = '';
  public sortField = '';
  public sortOrder = '';
  public pageSizeOptions: number[] = AppConstants.pageSizeOptions;
  public loading: boolean = false;
  public data: any;
  public isCurate: boolean = false;
  public isApproved: number = 1;
  public editLink = 'dictionary-management/disease/edit/';
  public currentMenuPermission: any;

  constructor(
    private diseaseService: DiseaseService,
    private commonService: CommonService,
    protected router: Router,
    private route: ActivatedRoute,
    private menuService: MenuService
  ) {}

  ngOnInit(): void {
    this.menuService.currentMenu.subscribe(currentMenu => {
      this.currentMenuPermission = currentMenu;
    });
    this.route.queryParams.subscribe((queryParams: any) => {
      
      this.isApproved =
        this.router.url.indexOf('curation-pending') >= 0 ? 0 : 1;
      this.editLink =
        this.router.url.indexOf('curation-pending') >= 0
          ? '/dictionary-management/disease/curation-pending/'
          : 'dictionary-management/disease/edit/';
      this.isCurate =
        this.router.url.indexOf('curation-pending') >= 0 ? true : false;
      this.title =
        (this.router.url.indexOf('curation-pending') >= 0
          ? 'Curate'
          : '') + ' Disease';
      this.getAll();
    });

  }

  /**
   * This function is user to get all User Listing
   * @author Dhaval Bera
   */
  getAll() {
    this.loading = true;
    this.diseaseService
      .getRecordByFilter(
        this.currentPage + 1,
        this.sortField,
        this.sortOrder,
        this.filterValue,
        this.pageSize,
        this.isApproved
      )
      .subscribe({
        next: (result: any) => {
          this.loading = false;
          this.data = result.data.data;
          this.totalRows = result.data.total;
        },
        error: (e) => {
          this.loading = false;
          console.log('disease Listing err :: ', e);
        },
        complete: () => {
          this.loading = false;
        },
      });
  }

  editAction(event: any) {
    if (this.isCurate) {
      this.router.navigate([this.editLink + event.id]);
    }
    this.router.navigate([this.editLink + event.id]);
  }
  /**
   * call Create Organ site api
   * @returns null
   */
  deleteDisease(event: any) {
    Swal.fire({
      title: 'Delete?',
      html: 'Are you sure want to delete the Disease?',
      imageUrl: '../../../../../assets/images/delete.svg',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      customClass: {
        confirmButton: 'btn mat-secoundary',
        cancelButton: 'btn mat-warn ml-1',
      },
    }).then((result) => {
      if (result.value) {
        this.diseaseService.delete(event.id).subscribe({
          next: (result: any) => {
            if (result.status === AppConstants.serverSuccessStatus) {
              this.commonService.showSuccessToast(
                'Disease deleted successfully'
              );
              this.getAll();
            } else {
              this.commonService.showErrorToast(
                "Disease can't be deleted. Please try again later."
              );
            }
          },
          error: (e: any) => {
            this.commonService.showErrorToast('Disease not found');
          },
        });
      }
      if (result.dismiss === Swal.DismissReason.cancel) {
      }
    });
  }

  /**
   * Make unapproved records
   * @param id
   */
  makeUnapproved(event: any) {
    Swal.fire({
      title: 'Unapproved?',
      html: 'Are you sure want to unapproved the Disease?',
      imageUrl: '../../../../../assets/images/unapproved.svg',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      customClass: {
        confirmButton: 'btn mat-secoundary',
        cancelButton: 'btn mat-warn ml-1',
      },
    }).then((result) => {
      if (result.value) {
        this.diseaseService
          .makeUnapproved(event.id)
          .subscribe((results: any) => {
            if (results.status === 1 || results.status === 200) {
              this.commonService.showSuccessToast(
                'Disease unapproved successfully'
              );
              this.getAll();
            } else {
              this.commonService.showErrorToast(
                "Disease can't be unapproved. Please try again later."
              );
            }
          });
      }
      if (result.dismiss === Swal.DismissReason.cancel) {
      }
    });
  }

  searchFilter(filterValue: any) {
    this.filterValue = filterValue;
    this.currentPage = 0;
    this.getAll();
  }
  SortFilter(sortState: any) {
    if (sortState.active !== '' && sortState.direction !== '') {
      this.sortField = sortState.active;
      this.sortOrder = sortState.direction;
      this.getAll();
    }
  }
  pageChanged(event: any) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getAll();
  }
}
